import gql from 'graphql-tag';

const DELETE_LISTING_UPLOAD = gql`
    mutation DeleteListingUpload($params: DeleteListingUploadParams!) {
        deleteListingUpload(params: $params)
    }
`;

export default DELETE_LISTING_UPLOAD;
